<template>
  <div id="etiquetas-toolbar">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Etiquetas
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarEtiquetas',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
